import parseAgentComment from './parse-agent-comment';
import parseUserComment from './parse-user-comment';
import parseConversation from './parse-conversation';
import parseGptConversation from './parse-gpt-conversation';

export const parseTicketCommentBy = {
  api: parseUserComment,
  web: parseAgentComment,
  chat: parseConversation,
  chat_transcript: parseConversation,
  native_messaging: parseConversation,
  chat_gpt: parseGptConversation,
};
